import { useNavigate } from 'react-router-dom';
import { useResponsive } from '../hooks/useResponsive';
import { useAuth } from '../context/AuthContext';

export default function WelcomePage() {
  const navigate = useNavigate();
  const { isDesktop } = useResponsive();
  const { enterGuestMode } = useAuth();

  const handleGuestMode = () => {
    enterGuestMode();
    navigate('/home');
  };

  return (
    <div className="h-screen h-dvh flex flex-col bg-white overflow-hidden overscroll-none touch-none">
      <div className={`flex-1 flex flex-col ${isDesktop ? 'max-w-md mx-auto w-full' : ''}`}>
        {/* Welcome Content */}
        <div className="flex-1 flex flex-col items-center justify-start px-8 pt-[148px]">
          {/* Logo Icon */}
          <img
            src="/logo/bonndleLogoIcon_Indigo.svg"
            alt="Bonndle"
            className="w-[72px] h-[72px] mb-4"
          />

          {/* Logo Wordmark */}
          <img
            src="/logo/bonndleLogoWordmark_Indigo.svg"
            alt="Bonndle"
            className="h-[25px] mb-7"
          />

          {/* Tagline */}
          <p className="text-lg text-gray-600 text-center max-w-xs leading-relaxed">
            Make life more rewarding<br />with your groups
          </p>
        </div>

        {/* Fixed Bottom Buttons */}
        <div className="fixed bottom-0 left-0 right-0 bg-white px-6 pt-4 pb-[calc(1rem+env(safe-area-inset-bottom))]">
          <div className={`space-y-2 ${isDesktop ? 'max-w-md mx-auto' : ''}`}>
            <button
              onClick={() => navigate('/signup')}
              className="w-full py-3.5 bg-indigo-600 text-white font-bold rounded-xl text-lg hover:bg-indigo-700 active:scale-[0.98] transition-all"
            >
              Get Started
            </button>
            <button
              onClick={() => navigate('/signin')}
              className="w-full py-3.5 bg-indigo-50 text-indigo-600 font-bold rounded-xl text-lg hover:bg-indigo-100 active:scale-[0.98] transition-all"
            >
              Sign In
            </button>
            <button
              onClick={handleGuestMode}
              className="w-full py-2 text-gray-500 font-medium text-base hover:text-gray-700 transition-colors"
            >
              Continue as Guest
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
